import { render, staticRenderFns } from "./ModalSolicitacaoCancelamentoAutorizacao.vue?vue&type=template&id=6adaa586&scoped=true"
import script from "./ModalSolicitacaoCancelamentoAutorizacao.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCancelamentoAutorizacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adaa586",
  null
  
)

export default component.exports